import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyBanner = Loadable({
    loader: () => import("pages/Banner/index"),
    loading: () => <PageLoader />,
});


function BannerRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyBanner />} />
            {/* <Route path="/detail/:order_id" element={<LazyOrderDetail />} /> */}
        </Routes>
    );
}

export default BannerRoute;
